import { InMemoryCache } from "@apollo/client";
import introspectionQueryResultData from "@/__generated__/introspectionResult";

export const createCache = () => {
  return new InMemoryCache({
    possibleTypes: introspectionQueryResultData.possibleTypes,
    typePolicies: {
      Query: {
        fields: {
          productOptions: {
            keyArgs: ["date", "id"]
          }
        }
      }
    }
  });
};

export default createCache();
